import * as React from 'react';

const FrequentUploaderBadge72 = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 72 72", width: 72, height: 72, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#C9F0EE",
    d: "M72 36c0 19.881-16.117 36-36 36C16.119 72 0 55.881 0 36 0 16.117 16.119 0 36 0c19.883 0 36 16.117 36 36"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#007782",
    d: "M30.028 33.83c.416-1.285 2.2-1.389 2.762-.16l1.382 3.019c.173.378.5.666.896.794l3.169 1.017c1.288.414 1.393 2.19.163 2.752l-3.03 1.379c-.38.173-.67.497-.798.892l-1.02 3.16c-.415 1.286-2.199 1.39-2.762.163l-1.382-3.02a1.5 1.5 0 0 0-.896-.796l-3.169-1.015c-1.29-.414-1.395-2.193-.162-2.754l3.03-1.38a1.48 1.48 0 0 0 .795-.892l1.022-3.16Z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#007782",
    d: "M43.141 23.138a4.497 4.497 0 0 1 4.309 4.207l1.485 23.78.007.461a4.5 4.5 0 0 1-3.757 4.25l-.46.05-23.829 1.482-.461.007a4.5 4.5 0 0 1-4.259-3.75l-.052-.458-1.486-23.78a4.495 4.495 0 0 1 3.755-4.71l.457-.053 23.83-1.482zM19.06 27.986c-.542.034-.97.448-1.044.965l-.008.225 1.485 23.78a1.124 1.124 0 0 0 1.193 1.051l23.83-1.482a1.124 1.124 0 0 0 1.052-1.191l-1.485-23.78a1.125 1.125 0 0 0-.965-1.042l-.228-.009z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#007782",
    d: "M52.967 15.623a4.61 4.61 0 0 1 4.4 4.807l-1.032 22.68a4.08 4.08 0 0 1-4.08 3.89 1.687 1.687 0 0 1-1.688-1.684c0-.93.758-1.684 1.69-1.684l-.003.02.003.002v-.022a.71.71 0 0 0 .705-.675l1.03-22.68a1.237 1.237 0 0 0-1.18-1.29l-21.955-.992a1.237 1.237 0 0 0-1.292 1.234v1.064l-.01.17a1.688 1.688 0 0 1-3.357.002l-.01-.172V19.23a4.61 4.61 0 0 1 4.821-4.6l21.957.993Z"
  }
));
FrequentUploaderBadge72.Size = 72;
FrequentUploaderBadge72.Title = "FrequentUploaderBadge";

export { FrequentUploaderBadge72 as default };
